"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Tab.css");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : TabC.js
* Description : Ce fichier contient la définition du composant TabC 
*               Ce composant est une barre de navigation avec des liens pour naviguer sur l'application coté gestion client
*               qui s'affichent sous forme d'onglets
* Date de création : 6 mars 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* TabC : ce composant est une barre de navigation avec des liens pour naviguer sur l'application 
*          qui s'affichent sous forme d'onglets
*
* Type : composant 
*
* Parametres : 
*  - tabNumber -- ce numéro permet d'identifier l’onglet actif correspondant à la section en cours pour l'afficher en vert. 
*                 Les autres onglets sont affichés en blanc.
*/
function TabC(_ref) {
  var tabNumber = _ref.tabNumber;
  // Define useState hooks
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    userPath = _useState2[0],
    setUserPath = _useState2[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    currentUser = _useAuth.currentUser;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (currentUser["role_name"] === "COMPANY_USER") {
      setUserPath("/profile");
    } else {
      setUserPath("/users");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Render component
  if (tabNumber === 1) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-c",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/equipments",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Produits client"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/batches",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Batchs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/plannings",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Plannings"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: userPath,
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Utilisateurs"
      })]
    });
  } else if (tabNumber === 2) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-c",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/equipments",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Produits client"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/protocols",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/batches",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Batchs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/plannings",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Plannings"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: userPath,
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Utilisateurs"
      })]
    });
  } else if (tabNumber === 3) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-c",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/equipments",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Produits client"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/batches",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Batchs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/plannings",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Plannings"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: userPath,
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Utilisateurs"
      })]
    });
  } else if (tabNumber === 4) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-c",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/equipments",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Produits client"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/batches",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Batchs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/plannings",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Plannings"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: userPath,
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Utilisateurs"
      })]
    });
  } else if (tabNumber === 5) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-c",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/equipments",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Produits client"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/batches",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Batchs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/plannings",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Plannings"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: userPath,
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Utilisateurs"
      })]
    });
  }
}
var _default = exports["default"] = TabC;